export interface SearchUserByEmailResult {
  pxEnabled: boolean;
}

export class UsersClientError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'UsersClientError';
  }
}

export async function searchUserByEmailRequest(email: string): Promise<SearchUserByEmailResult> {
  const response = await fetch('/api/users/search', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email }),
  });

  const payload = await response.json();

  if (!response.ok) {
    throw new UsersClientError(payload.message || 'Request failed');
  }

  return payload as SearchUserByEmailResult;
}
